import cn from "classnames";

// types
import { PerformanceHistory } from "types/performance-history-.types";

// components
import DisplayValue from "../DisplayValue";

// store
import { useSearchStore } from "store/searchStore";

// utils
import { formatCertDate, ensureLeading$ } from "utils/profile";

// icons
import { UserIcon, PhoneIcon } from "../../icons";

// styles
import styles from "./PerformanceHistorySection.module.scss";

type PerformanceHistorySectionProps = {
  performance_history: PerformanceHistory[];
};

export default function PerformanceHistorySection({
  performance_history,
}: PerformanceHistorySectionProps) {

  const performanceHistoryItems = performance_history.filter(item => !item.deleted_at)

  const isEmpty = !performanceHistoryItems || performanceHistoryItems.length === 0;

  return (
    <div className={styles["performance-history-root"]}>
      <h2 className={styles["heading"]} id="performance-history" tabIndex={-1}>
        Performance history
      </h2>

      <div className={styles["performance-list"]}>
        {!isEmpty ? (
          performanceHistoryItems.map((item, i) => (
            <PerformanceCard key={i} {...item} />
          ))
        ) : (
          <p className={styles["not-provided"]}>Not Provided</p>
        )}
      </div>
    </div>
  );
}

function PerformanceCard(props: PerformanceHistory) {
  const missingContractPeriod =
    !props?.contract_start_date && !props?.contract_end_date;

  const contractPeriod = `${
    props?.contract_start_date
      ? formatCertDate(props.contract_start_date.toString())
      : "Start date not provided"
  } - ${
    props?.contract_end_date
      ? formatCertDate(props.contract_end_date.toString())
      : "End date not provided"
  }`;

  return (
    <div className={styles["performance-card"]}>
      <div className={cn(styles["space-y-2"], styles["mb-4"])}>
        <DisplayValue
          messageElement="h4"
          className={styles["title"]}
          value={props?.name}
        />

        <div className={styles["data-field"]}>
          <h5 className={styles["label"]}>Contract number:</h5>
          <DisplayValue
            messageElement="p"
            className={styles["value"]}
            value={props?.contract}
          />
        </div>
      </div>

      <div className={cn(styles["mb-4"])}>
        <div className={styles["data-field"]}>
          <h5 className={styles["label"]}>Contract period:</h5>
          <DisplayValue
            messageElement="p"
            className={styles["value"]}
            value={missingContractPeriod ? false : contractPeriod}
          />
        </div>
        <div className={styles["data-field"]}>
          <h5 className={styles["label"]}>Contract value:</h5>
          <DisplayValue
            messageElement="p"
            className={styles["value"]}
            value={ensureLeading$(props?.value)}
          />
        </div>
      </div>

      <div className={cn(styles["space-y-2"], styles["mb-4"])}>
        <div className={cn(styles["data-field"], styles["data-field_icon"])}>
          <UserIcon aria-label="Person icon" />
          <div className={styles["group"]}>
            <h5 className={styles["label"]}>Contact person</h5>
            <DisplayValue
              messageElement="p"
              className={styles["value"]}
              value={props?.contract_contact}
            />
          </div>
        </div>

        <div className={cn(styles["data-field"], styles["data-field_icon"])}>
          <PhoneIcon aria-label="Phone icon" />
          <div className={styles["group"]}>
            <h5 className={styles["label"]}>Phone number</h5>
            <DisplayValue
              messageElement="p"
              className={styles["value"]}
              value={props?.contract_contact_phone}
            />
          </div>
        </div>
      </div>
    </div>
  );
}
